export default __webpack_public_path__ + "static/media/pictogramBeaconMarketplace48.6a04eb30.svg";